import { useContext } from 'react';
import { getUserAvatarUrl } from '@fundera/fundera-utilities';
import { AppContext } from '../providers/AppContext';

const authorMapper = author => {
  const context = useContext(AppContext);
  const authorProfile = `${context.author.url}${author.slug}`;
  const authorAbsoluteProfile = author.slug
    ? `${context.author.absoluteUrl}${author.slug}`
    : '';

  const avatarUrl = getUserAvatarUrl(author, context.author.avatarPrefix);

  const props = {
    gravatar: avatarUrl,
    profile: authorProfile,
    absoluteProfile: authorAbsoluteProfile,
    name: author.name || '',
    hasJobTitle: false,
  };

  if (author.authorBio) {
    const { authorBio } = author;
    props.name = authorBio.name || '';
    props.jobTitle = authorBio.jobTitle || '';
    props.description = authorBio.description || '';
    props.companyName = authorBio.company;
    props.companyUrl = authorBio.companyUrl;
    props.hasJobTitle = authorBio.company && authorBio.jobTitle;
  }

  if (author.fdsAuthorBio) {
    const bio = author.fdsAuthorBio;
    props.gravatar =
      (bio.avatar && bio.avatar.sourceUrl) || props.gravatar || '';
    props.name = author.name;
    props.jobTitle = bio.jobTitle || '';
    props.description =
      bio.biography && bio.biography[0] && bio.biography[0].content;
    props.companyName = bio.company;
    props.companyUrl = bio.companyUrl;
    props.firstName = author.firstName;
    props.biography = bio.biography;
    props.hasJobTitle = bio.company && bio.jobTitle;
    props.knowsAbout = bio.knowsAbout;
    props.award = bio.award;
    props.alumniOf = bio.alumniOf;
    props.affiliation = bio.affiliation;
    props.honorificSuffix = bio.honorificSuffix;
  }

  return props;
};

export default authorMapper;
